import { render, staticRenderFns } from "./healthnew.vue?vue&type=template&id=2830c826&scoped=true"
import script from "./healthnew.vue?vue&type=script&lang=js"
export * from "./healthnew.vue?vue&type=script&lang=js"
import style0 from "./healthnew.vue?vue&type=style&index=0&id=2830c826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830c826",
  null
  
)

export default component.exports